// eslint-disable-next-line import/no-cycle
import { RootState } from '@stores/index';
import { useSelector } from 'react-redux';

const useNetworkStatus = () => {
  const { status } = useSelector((state: RootState) => state?.networkStatus);
  // const dispatch: AppDispatch = useDispatch();

  // const { data: vendor } = useGetVendorWithNetworkStatus();
  // const { isLoading, isError, isSuccess } = useHealthCheck(vendor?.hasOfflineAccess || false);

  // useEffect(() => {
  //   if (!isLoading && isSuccess) {
  //     dispatch(networkSlice.actions.setNetworkStatus(true));
  //   }
  //   if (!isLoading && isError) {
  //     dispatch(networkSlice.actions.setNetworkStatus(false));
  //     // if (status !== false) {
  //     //   router.replace('/bo/orders');
  //     //   router.reload();
  //     // }
  //   }
  // }, [isError, isSuccess, isLoading, dispatch, status]);

  return { networkStatus: status };
};

export default useNetworkStatus;
